import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getNotificationData,
  setShowCompleteChallengeBanner,
  setShowCompleteQuizBanner,
  setShowDownloadCertificateBanner,
  setShowExtendChallengeBanner,
  setShowJesCalculatedBanner,
  setShowJesIsNotCalculatedBanner,
  setShowStartChallengeBanner,
  setShowUnlockCertificateBanner,
  setShowUpgradeBanner,
} from "../../redux/actions/adBanner";

import { leadScoringActivity, userActivity } from "../../common/constants";
import { IKImage } from "imagekitio-react";
import { editOneDayChallenge } from "../../redux/actions/userActivity";
import { createNewChallenge } from "../../redux/actions/quiz";
import { addUserActivity } from "../../redux/actions/profileDetails";
import { createLeadScore } from "../../redux/actions/pricing";
import { SET_COMPLETE_QUIZ_TIMER } from "../../redux/actions/types";
import BannerDummyTimer from "./BannerDummyTimer";
import BannerLiveTimer from "./BannerLiveTimer";

const AdBanner = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [notification, setNotification] = useState(null);
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const location = useLocation();
  const [showBanner, setShowBanner] = useState(false);
  const { course_slug, skill_slug, mskill_slug, contentId } = useParams();
  const regex = /^.*\/.*\/.*\/.*\/\d+$/;
  const isDarkOverlay = useSelector((store) => store?.appTheme?.blackOverlay);
  const pathname = location?.pathname;
  const userBannerData = useSelector((store) => store?.userBannerData);

  console.log("saturday", userBannerData);

  console.log(
    "This is params",
    course_slug,
    skill_slug,
    mskill_slug,
    contentId
  );
  console.log(useParams());
  console.log(location);

  const showCompleteQuizBanner = useSelector(
    (store) => store?.preferences?.showQuizBanner
  );
  const showStartChallengeBanner = useSelector(
    (store) => store?.preferences?.showStartChallengeBanner
  );
  const showCompleteChallengeBanner = useSelector(
    (store) => store?.preferences?.showCompleteChallengeBanner
  );
  const showExtendChallengeBanner = useSelector(
    (store) => store?.preferences?.showExtendChallengeBanner
  );
  const showUnlockCertificateBanner = useSelector(
    (store) => store?.preferences?.showUnlockCertificateBanner
  );
  const showUpgradeBanner = useSelector(
    (store) => store?.preferences?.showUpgradeBanner
  );

  const showJesCalculatedBanner = useSelector(
    (store) => store?.preferences?.showJesCalculatedBanner
  );
  const showJesIsNotCalculatedBanner = useSelector(
    (store) => store?.preferences?.showJesIsNotCalculatedBanner
  );
  const showDownloadCertificateBanner = useSelector(
    (store) => store?.preferences?.showDownloadCertificateBanner
  );

  console.log("answer1", showBanner, notification);
  function checkNotificationDisplay(notification, type) {
    console.log("answer", { type, timer: notification, showUpgradeBanner });
    if (type === "complete_first_quiz") {
      setShowBanner(true);
    } else if (type === "start_challenge" && showStartChallengeBanner) {
      setShowBanner(true);
    } else if (type === "complete_challenge" && showCompleteChallengeBanner) {
      setShowBanner(true);
    } else if (type === "failed_challenge" && showExtendChallengeBanner) {
      setShowBanner(true);
    } else if (
      type === "unlock_certificate" &&
      !notification?.notification_details?.is_timer_expired
    ) {
      console.log("answerx");
      setShowBanner(true);
    } else if (
      type === "unlock_certificate" &&
      notification?.notification_details?.is_timer_expired &&
      showUpgradeBanner
    ) {
      console.log("answery");
      setShowBanner(true);
    } else if (type === "calculate_jes" && showJesIsNotCalculatedBanner) {
      setShowBanner(true);
    } else if (type === "view_jes" && showJesCalculatedBanner) {
      setShowBanner(true);
    } else if (
      type === "download_certificate" &&
      showDownloadCertificateBanner
    ) {
      setShowBanner(true);
    } else setShowBanner(false);
  }


  
  useEffect(() => {
    if (
      pathname === "/" ||
      pathname?.includes("/onboarding") ||
      pathname?.includes("/verification") ||
      pathname?.includes("/login") ||
      pathname?.includes("/set-password") ||
      pathname?.includes("/verification") ||
      pathname?.includes("/verify/certificate")
    ) {
      return;
    }

    if (user_id === 0 || user_id === null || user_id === undefined) {
      return;
    }

    // if(i

    if (userBannerData && userBannerData?.cache_time < Date.now()) {
      dispatch(
        getNotificationData(
          user_id,
          (successObj) => {
            setNotification(successObj);

            if (
              successObj?.notification_template?.["template_name"] ===
                "unlock_certificate" &&
              successObj?.notification_details?.is_timer_expired
            ) {
              const newNotificationTemplate = {
                ...successObj?.notification_template,
                notification_title:
                  successObj?.notification_details
                    ?.timer_expiry_notification_title,
                notification_button_text:
                  successObj?.notification_details
                    ?.timer_expiry_notification_button_text,

                notification_icon:
                  successObj?.notification_details
                    ?.timer_expiry_notification_icon,
                notification_timer: "none",
              };

              const newNotification = {
                ...notification,
                notification_template: newNotificationTemplate,
                notification_details: successObj?.notification_details,
              };
              checkNotificationDisplay(
                newNotification,
                successObj?.notification_template?.template_name
              );

              setNotification((prev) => ({
                ...prev,
                notification_template: newNotificationTemplate,
              }));
            } else {
              if (
                successObj?.notification_template?.["template_name"] ===
                "complete_first_quiz"
              ) {
                dispatch({
                  type: SET_COMPLETE_QUIZ_TIMER,
                  payload: Date.now() + 86400000,
                });
              }

              checkNotificationDisplay(
                notification,
                successObj?.notification_template?.template_name
              );
            }
          },
          (errObj) => {}
        )
      );
    } else {
      setNotification(userBannerData);

      if (
        userBannerData?.notification_template?.["template_name"] ===
          "unlock_certificate" &&
        userBannerData?.notification_details?.is_timer_expired
      ) {
        const newNotificationTemplate = {
          ...userBannerData?.notification_template,
          notification_title:
            userBannerData?.notification_details
              ?.timer_expiry_notification_title,
          notification_button_text:
            userBannerData?.notification_details
              ?.timer_expiry_notification_button_text,

          notification_icon:
            userBannerData?.notification_details
              ?.timer_expiry_notification_icon,
          notification_timer: "none",
        };

        const newNotification = {
          ...notification,
          notification_template: newNotificationTemplate,
          notification_details: userBannerData?.notification_details,
        };
        checkNotificationDisplay(
          newNotification,
          userBannerData?.notification_template?.template_name
        );

        setNotification((prev) => ({
          ...prev,
          notification_template: newNotificationTemplate,
        }));
      } else {
        if (
          userBannerData?.notification_template?.["template_name"] ===
          "complete_first_quiz"
        ) {
          dispatch({
            type: SET_COMPLETE_QUIZ_TIMER,
            payload: Date.now() + 86400000,
          });
        }

        checkNotificationDisplay(
          notification,
          userBannerData?.notification_template?.template_name
        );
      }
    }
  }, [location.pathname, user_id]);

  const createChallengeHandler = async (details) => {
    dispatch(
      addUserActivity(
        user_id,
        userActivity.CHALLENGE_ACCEPTED,
        null,
        false,
        null,
        (successObj) => {}
      )
    );

    dispatch(
      createLeadScore(user_id, leadScoringActivity.ACCEPTED_CHALLENGE.type)
    );

    dispatch(
      createNewChallenge(
        user_id,
        details?.mskill_slug,
        async (successObj) => {}
      )
    );
  };

  console.log("notification", userBannerData?.cache_time , Date.now());
  function notificationHandler(type, details) {
    console.log("type", type);
    console.log("details", details);
    let course_slug = null;
    let skill_slug = null;
    let mskill_slug = null;
    let lesson_id = null;
    let challenge_data = null;
    if (details) {
      course_slug = details?.course_slug;
      skill_slug = details?.skill_slug;
      mskill_slug = details?.mskill_slug;
      lesson_id = details?.lesson_id;
      challenge_data = details?.challenge_data;
    }

    if (type === "complete_first_quiz") {
      //   dispatch(setShowCompleteQuizBanner(false));
      navigate(`/${course_slug}/${skill_slug}/${mskill_slug}/${lesson_id}`);
    } else if (type === "start_challenge") {
      createChallengeHandler(details);
      dispatch(setShowStartChallengeBanner(false));
      navigate(`/${course_slug}/${skill_slug}/${mskill_slug}/${lesson_id}`);
    } else if (type === "complete_challenge") {
      dispatch(setShowCompleteChallengeBanner(false));
      navigate(`/${course_slug}/${skill_slug}/${mskill_slug}/${lesson_id}`);
    } else if (type === "failed_challenge") {
      dispatch(setShowExtendChallengeBanner(false));
      dispatch(editOneDayChallenge(challenge_data, true));
      navigate(`/${course_slug}/${skill_slug}/${mskill_slug}/${lesson_id}`);
      dispatch(setShowCompleteChallengeBanner(true));
    } else if (
      type === "unlock_certificate" &&
      !notification?.notification_details?.is_timer_expired
    ) {
      dispatch(setShowUnlockCertificateBanner(false));
      navigate("/my-profile/user/certificates");
    } else if (type === "unlock_certificate") {
      dispatch(setShowUpgradeBanner(false));
      navigate("/pricing");
    } else if (type === "calculate_jes") {
      dispatch(setShowJesIsNotCalculatedBanner(false));
      navigate("/my-profile/user");
    } else if (type === "view_jes") {
      dispatch(setShowJesCalculatedBanner(false));
      navigate("/my-profile/user");
    } else if (type === "download_certificate") {
      dispatch(setShowDownloadCertificateBanner(false));
      navigate("/my-profile/user/certificates");
    }
  }

  function closeHandler(type) {
    if (type === "complete_quiz") {
      dispatch(setShowCompleteQuizBanner(false));
    } else if (type === "start_challenge") {
      dispatch(setShowStartChallengeBanner(false));
    } else if (type === "complete_challenge") {
      dispatch(setShowCompleteChallengeBanner(false));
    } else if (type === "failed_challenge") {
      dispatch(setShowExtendChallengeBanner(false));
    } else if (
      type === "unlock_certificate" &&
      !notification?.notification_details?.is_timer_expired
    ) {
      dispatch(setShowUnlockCertificateBanner(false));
    } else if (type === "unlock_certificate") {
      dispatch(setShowUpgradeBanner(false));
    } else if (type === "calculate_jes") {
      dispatch(setShowJesIsNotCalculatedBanner(false));
    } else if (type === "view_jes") {
      dispatch(setShowJesCalculatedBanner(false));
    } else if (type === "download_certificate") {
      dispatch(setShowDownloadCertificateBanner(false));
    }
  }

  return (
    <>
      {user_id && notification && showBanner && (
        <div className="sticky top-0 z-10 flex h-fit w-full flex-col bg-[#0E5F79] md:flex-row">
          <div className="flex w-full grow items-center gap-1 px-2 pt-3 pb-1 md:ml-60 md:h-fit md:w-fit  md:gap-5 md:py-5">
            {notification?.notification_template?.["notification_icon"].length >
              0 && (
              <img
                urlEndpoint="https://assets.learntube.ai/files/"
                src={notification?.notification_template?.notification_icon}
                className="h-10 w-10 md:h-10 md:w-10"
                transformation={[
                  {
                    height: "60",
                    width: "60",
                  },
                ]}
              />
            )}
            <div className="text-start w-full text-sm font-bold text-white md:text-xl">
              {notification?.notification_template?.notification_title}
              <span className="-ml-1 inline-block">
                {notification?.notification_template?.notification_timer ===
                "dummy" ? (
                  <BannerDummyTimer />
                ) : notification?.notification_template?.notification_timer ===
                  "live" ? (
                  <BannerLiveTimer
                    countDownDate={
                      notification?.notification_details?.timer_expires_at
                    }
                  />
                ) : null}
              </span>
            </div>
            {notification?.notification_template?.is_closable && (
              <FontAwesomeIcon
                onClick={(e) => {
                  closeHandler(
                    notification?.notification_template?.template_name
                  );
                }}
                className="fixed top-0 right-0 z-[9999999] cursor-pointer self-start px-1 text-white md:mr-1 md:hidden md:hover:text-gray-300"
                size="sm"
                icon={faClose}
              />
            )}
            {/* {window.innerWidth > 500 && <span className=""><Timer isBannerTimer={true} /></span>} */}
          </div>
          {notification && (
            <button
              onClick={(e) => {
                notificationHandler(
                  notification?.notification_template?.template_name,
                  notification?.notification_details
                );
              }}
              className="mx-2 my-2 h-2/3 rounded-md bg-[#FAC232] p-2 text-sm font-bold md:my-auto md:mx-auto md:mr-20 md:px-3 md:py-1 md:text-lg md:hover:bg-yellow-500"
            >
              {notification?.notification_template?.notification_button_text}
            </button>
          )}
          {notification?.notification_template?.is_closable && (
            <FontAwesomeIcon
              onClick={(e) => {}}
              className="z-[9999999] mx-2 hidden cursor-pointer self-start text-white md:flex md:hover:text-gray-300"
              size="lg"
              icon={faClose}
            />
          )}
        </div>
      )}
    </>
  );
};

export default AdBanner;
